export interface SortOptions {
    sortBy?: string;
    direction?: SortDirection;
}

export enum SortDirection {
    Unspecified,
    Ascending,
    Descending
}